<template>
  <div class="edit-club-story">
    <div class="nav">
      <router-link :to="{ name: 'clubStoryManage' }">用户故事管理</router-link>
      / 编辑用户故事
    </div>

    <b-form @submit="onSubmit" >
      <b-form-group
        id="input-group-1"
        label="题目:"
        label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.title"
          type="text"
          required
          placeholder="输入文章题目"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="项目地:"
        label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.content.place"
          type="text"
          required
          placeholder="输入项目地"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-3"
        label="上传视频:"
        label-for="input-3">
        <!--<b-form-input-->
          <!--id="input-3"-->
          <!--v-model="form.content.videoPath"-->
          <!--type="text"-->
          <!--required-->
          <!--placeholder="url"-->
        <!--&gt;</b-form-input>-->
        <div v-if="form.content.videoPath">
          <video controls :src="'/data' + form.content.videoPath" class="video">
            你的浏览器不支持HTML5，建议更换成Chrome浏览器
          </video>
        </div>
        <div>
          <b-form-file class="d-inline-block" style="width: 200px"
            v-model="video.data"
            :disabled="video.disabled"
            :state="false"
            placeholder="选择视频文件"
            drop-placeholder="拖拽视频文件到此处">
          </b-form-file>
          <b-button @click="uploadVideo"
                    :disabled="video.disabled"
                    variant="outline-primary"
                    style="vertical-align: bottom; margin-left: 10px">
            {{ video.buttonText }}
          </b-button>
        </div>
      </b-form-group>

      <b-form-group id="input-group-4" label="简述:" label-for="input-2">
        <b-form-textarea
          id="input-4"
          v-model="form.content.text"
          placeholder="日记简述"
          rows="5"
          max-rows="8"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group label="是否直接发布:">
        <b-form-radio-group
          id="radio-group-1"
          v-model="options.publish"
          :options="[{ text: '是', value: true }, { text: '否', value: false }]"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group>
      <b-button @click="onSubmit" variant="primary">提交</b-button>
    </b-form>
  </div>
</template>

<script>

import clubStoryAdminApi from '../../api/clubStoryAdmin'
import fileUploadApi from '../../api/fileUpload'

export default {
  name: 'editClubStory',
  data () {
    return {
      form: {
        id: '',
        title: '',
        content: {
          place: '',
          text: '',
          videoPath: ''
        }
      },
      options: {
        publish: false
      },
      video: fileUploadApi.uploadObject.init()
    }
  },
  components: {
  },
  computed: {

  },
  mounted () {
    let id = this.$route.params.id
    if (id > 0) {
      this.getData(id)
    }
  },
  methods: {
    onSubmit () {
      this.modifyData(this.options.publish)
    },
    getData (id) {
      clubStoryAdminApi.get(id).then(resp => {
        this.form = resp
        this.form.content = JSON.parse(resp.content)
      }).catch(error => {
        console.error(error)
      })
    },
    newData (publish) {
      let item = this.form
      clubStoryAdminApi.add({
        title: item.title,
        content: JSON.stringify(item.content),
        publish: publish
      }).then(resp => {
        if (this.respOk(resp)) {
          this.$toasted.global.pop_success('新增成功')
          this.getData(this.param)
        } else {
          this.$toasted.global.pop_error('操作失败:\n' + resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('操作失败:\n' + error)
      })
    },
    modifyData (publish) {
      let item = this.form

      if (!item.title || !item.content || !item.content.place || !item.content.text || !item.content.videoPath) {
        this.$toasted.global.pop_error('请填写完整后再提交')
        return
      }

      if (!item.id || item.id <= 0) {
        this.newData(publish)
        return
      }

      clubStoryAdminApi.update({
        id: item.id,
        title: item.title,
        content: JSON.stringify(item.content),
        publish: publish
      }).then(resp => {
        if (this.respOk(resp)) {
          this.$toasted.global.pop_success('修改成功')
          this.getData(item.id)
        } else {
          this.$toasted.global.pop_error('操作失败:\n' + resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('修改失败\n' + error)
      })
    },
    respOk (resp) {
      return resp.code === 200 && resp.bizCode === 200
    },
    uploadVideo () {
      if (!this.video.data) {
        this.$toasted.global.pop_error('请选择文件')
        return
      }
      fileUploadApi.uploadObject.cannotUpload(this.video)
      fileUploadApi.upload('/videos', this.video.data).then(resp => {
        if (this.respOk(resp)) {
          this.$toasted.global.pop_success('上传成功')
          this.form.content.videoPath = resp.data
        } else {
          this.$toasted.global.pop_error('上传失败:\n' + resp.msg)
        }
        fileUploadApi.uploadObject.canUpload(this.video)
      }).catch(error => {
        this.$toasted.global.pop_error('上传失败:\n' + error)
        fileUploadApi.uploadObject.canUpload(this.video)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-club-story {
  max-width: 900px;
  margin: 10px auto;
}
.nav {
  margin-bottom: 10px;
}
.video {
  width: 300px;
  height: 200px;
}
</style>
